"use strict";

exports.__esModule = true;
exports.ChangeOperatorUserAction = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _ChangeOperatorActionElement = require("./ChangeOperatorActionElement");
var _ChangeOperatorActionFields = require("./ChangeOperatorActionFields");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ChangeOperatorUserAction = exports.ChangeOperatorUserAction = {
  name: "ChangeOperator",
  icon: "new-person",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ChangeOperatorUserActionDefinition.label",
    defaultMessage: "Change Operator"
  }),
  description: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ChangeOperatorUserActionDefinition.description",
    defaultMessage: "Enables user to change operator"
  }),
  requiresContexts: ["device"],
  requiresProps: [],
  components: {
    Element: _ChangeOperatorActionElement.ChangeOperatorActionElement,
    Fields: _ChangeOperatorActionFields.ChangeOperatorActionFields
  }
};